/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { Component } from 'react';

import GeneralService from '../../services/GeneralService';
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // console.log("error", error);
    GeneralService.logError(this.props.errorAt, error.toString(), errorInfo.componentStack).then(data => {
      window.location.href = "https://www.umangwellness.com/error?id=" + data.errorId;
    });
  }

  render() {
    // if (this.state.hasError) {
    //   return (
    //     <div>Oops!</div>
    //   );
    // }
    // Render children if there's no error
    return this.props.children;
  }
}

export default ErrorBoundary;